<template>
  <div class="d-flex">
    <div>
      <p class="detail-table-name">Paid Absent Day</p>
      <table class="detail-table w-100">
        <thead>
          <tr>
            <th>Now Left</th>
            <th>Request This Month</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="paidAbsentDay">
            <td>{{ paidAbsentDay.nowLeft }}</td>
            <td>{{ paidAbsentDay.request }}</td>
          </tr>
        </tbody>
      </table>
      <p class="unit-name">Unit: Days</p>
    </div>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Moment } from 'moment'
import { PaidAbsentDay, Timesheet } from '@/store/timesheets/types'

@Component
export default class PaidAbsentDayComponent extends Vue {
  @Prop() date!: Moment

  @Prop() paidAbsentDay!: PaidAbsentDay
}
</script>

<style scoped>
.detail-table-name {
  border-left:3px solid #BFBFBF;
  padding-left:5px;
  margin-bottom:10px;
  font-weight: bold;
}

.detail-table {
  table-layout: fixed;
  border-collapse:collapse;
  margin-bottom:10px;
}

.detail-table th {
  padding:10px;
  text-align: center;
}

.detail-table td {
  padding:10px;
  text-align: center;
}

.detail-table thead tr {
  background: #fff;
  border: 2px solid #dcdcdc
}

.detail-table tbody tr:nth-child(odd) {
  background: #D8D8D8;
}

.detail-table tbody tr:nth-child(even) {
  background: #fff;
}

.detail-table tbody tr.total {
  background: #D8E2F3;
}

.unit-name {
  text-align: right;
}
</style>
